// 全局时间过滤器
import Vue from 'vue'
// 时间戳转换
Vue.filter('filterTime', function(time, number) {
  if (!time) {
    return
  }
  const date = new Date(parseInt(time))
  const dateNumFun = num => (num < 10 ? `0${num}` : num)
  const [Y, M, D, h, m, s] = [
    // es6 解构赋值
    date.getFullYear(),
    dateNumFun(date.getMonth() + 1),
    dateNumFun(date.getDate()),
    dateNumFun(date.getHours()),
    dateNumFun(date.getMinutes()),
    dateNumFun(date.getSeconds())
  ]
  if (number === '1') {
    return `${Y}-${M}-${D}`
  } else if (number === '2') {
    return `${Y}-${M}-${D} ${h}:${m}`
  } else if (number === '' || number === null || number === undefined) {
    return `${Y}-${M}-${D} ${h}:${m}:${s}` // 一定要注意是反引号，否则无效。
  }
})
// 将Data格式时间转成标准时间
// Vue.filter('FilterDataTime1', function(datetime) {
//   console.log(datetime)

//   // 转为正常的时间格式 年-月-日 时:分:秒
//   const Tpos = datetime.indexOf('T')
//   const Zpos = datetime.indexOf('Z')
//   const yearmonthday = datetime.substr(0, Tpos)
//   const hourminutesecond = datetime.substr(Tpos + 1, Zpos - Tpos - 1)
//   const newdatetime = yearmonthday + ' ' + hourminutesecond // 2017-03-31 08:02:06
//   console.log(newdatetime)

//   // 处理成为时间戳
//   let times = new Date(Date.parse(newdatetime))
//   times = times.getTime()
//   times = times / 1000

//   // 增加8个小时，北京时间比utc时间多八个时区
//   var timestamp = times + 8 * 60 * 60

//   // 时间戳转为时间
//   var beijingDatetime = new Date(parseInt(timestamp) * 1000)
//     .toLocaleString()
//     .replace(/年|月/g, '-')
//     .replace(/日/g, ' ')
//   return beijingDatetime
// })

// 将后端特殊时间格式2019-01-03T00:18:21.000+0000转成标准时间
Vue.filter('FilterDataTime', function(datetime) {
  var dateee = new Date(datetime).toJSON()
  return new Date(+new Date(dateee) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, ' ')
    .replace(/\.[\d]{3}Z/, '')
})

// 通过0,1值写出其对应名称
Vue.filter('FilterNumber', function(value, oneName, TwoName) {
  if (value === null) {
    return '不详'
  } else {
    return value === 0 ? oneName : TwoName
  }
})

// 数据为null时显示
Vue.filter('FilterNull', function(value) {
  return value === null ? '无' : value
})

Vue.filter('FilterName', function(value, e, x, y, z, h, i, j, k, l) {
  switch (value) {
    case 0:
      return e
    case 1:
      return x
    case 2:
      return y
    case 3:
      return z
    case 4:
      return h
    case 5:
      return i
    case 6:
      return j
    case 7:
      return k
    case undefined:
      return l
  }
})

// 去除字符中多余字符
Vue.filter('FilterTimeObj', function(value, a) {
  return value.split(a).join('')
})
// JS获取富文本里的文字内容
Vue.filter('getText', function(str) {
  return str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '')
})
